import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer, Provider } from "mobx-react";
import TransactionTable from "./TransactionTable";
import Metrics from "../../store/Metrics";
import NumberFormat from "react-number-format";

@observer
class MoneyTransfer extends Component {
  constructor(props) {
    super(props);
    // props from calling component PolicyDashboard:
    //     onSendMoney
    //     transferRequestSent
    //     transactions
    //     countryId
    //     roleName
    //     countryName
    //     hasGameStarted

    this.state = {
      metricsBudget: null,
      sendToCountry: "null",
      sendAmount: 0,
      inputValue: 0,
      temp: 0,
    };
  }

  onChange = (e) => {
    if (/^[0-9]\d*$/.test(e.floatValue)) {
      // e.preventDefault();
      // console.log(e.floatValue);
    }
    // console.log("THE VALUE!!!!!", e);
    // console.log(
    //   "Country ID: " +
    //     this.state.sendToCountry +
    //     " countries from props: " +
    //     this.props.countries.country_data +
    //     " current transaction amounts: " +
    //     this.props.transactions
    // );
    const value = e.floatValue;

    this.setState({
      sendAmount: value,
      inputValue: value,
    });
  };

  sendMoney = (e) => {
    e.preventDefault();

    // console.group("MoneyTransfer:sendMoney");
    // console.log("target", e.target);
    // console.log("country", this.state.sendToCountry);
    // console.log("amount", this.state.sendAmount);
    // console.groupEnd();

    this.props
      .onSendMoney(this.state.sendToCountry, this.state.sendAmount)
      .then(() => {
        this.setState(() => ({
          sendToCountry: "null",
          sendAmount: 0,
          inputValue: 0,
        }));
      })
      .catch((error) => console.log(error));
  };

  selectCountry = (e) => {
    this.setState({ sendToCountry: e.target.value });
  };

  cancelMoney = (e) => {
    e.preventDefault();
    const toCountry = e.target.getAttribute("tocountry");
    const fromCountry = this.props.countryName;
    // console.log(`Cancelling ${fromCountry}'s commitment to ${toCountry}`)
    this.props.onCancelMoney(fromCountry, toCountry);
  };
  cancelATGMoney = (e) => {
    e.preventDefault();
    const toCountry = e.target.getAttribute("tocountry");
    const fromCountry = this.props.countryName;
    // console.log(`Cancelling ${fromCountry}'s ATG commitment to ${toCountry}`)
    this.props.onCancelATGMoney(fromCountry, toCountry);
  };

  componentWillMount() {
    this.setState({
      metricsBudget: this.props.metrics.metrics.budget,
    });
  }

  render() {
    const {
      countries,
      metrics,
      transferRequestSent,
      transactions,
      atgfund,
      countryId,
      roleName,
      countryName,
      hasGameStarted,
      atgPres,
      gameHasAdvanced,
    } = this.props;
    const countryMetrics = metrics.metrics;

    const availableFund =
      countryMetrics && countryId > 0
        ? this.state.sendAmount
          ? countryMetrics["next_budget"] - parseInt(this.state.sendAmount)
          : countryMetrics["next_budget"]
        : this.state.sendAmount
          ? this.props.atgFund - parseInt(this.state.sendAmount)
          : this.props.atgFund;

    const isTransferAllowed = availableFund && availableFund >= 0;
    // console.log(this.state.metricsBudget);
    // console.log("Props: " + JSON.stringify(this.props))
    // console.group("MoneyTransfer:render");
    // console.log('countryMetrics', countryMetrics);
    // console.log('sendAmount', parseInt(this.state.sendAmount));
    // console.log('next_budget', countryMetrics['next_budget'] - parseInt(this.state.sendAmount));
    // console.log('atgfund prop', this.props.atgFund);
    // console.groupEnd();

    return (
      <Provider metrics={this.props.metrics}>
        <div className="flex flex-items-center flex-justify-center gap__container">
          <div className="graphs__container">
            <div className={`shadow graphs__wrapper`}>
              <h3>
                {countryId > 0
                  ? "International Financial Commitments"
                  : "ATG Financial Commitments"}
              </h3>
              <hr />

              {!(roleName === "ATG Delegate" && countryId > 0) && (
                <div className="flex flex-wrap flex-40-60">
                  <div className="container">
                    <p style={{ marginTop: 10, marginBottom: 0 }}>
                      {countryId > 0
                        ? "Available budget ($)"
                        : "Available fund ($)"}
                    </p>
                  </div>
                  <div className="container">
                    <p
                      style={{
                        marginTop: 10,
                        marginBottom: 0,
                      }}
                    >
                      {availableFund && availableFund.toLocaleString()}
                    </p>
                  </div>
                </div>
              )}

              {(roleName === "Prime Minister" && countryId > 0) ||
              (roleName === "ATG Delegate" &&
                countryName === atgPres &&
                !(countryId > 0)) ? (
                <form
                  className="signup_form"
                  method="post"
                  onSubmit={this.sendMoney}
                >
                  <br />
                  <div className="flex flex-wrap flex-40-60">
                    <div className="container">
                      <p style={{ marginTop: 10 }}>Sign Commitment With</p>
                    </div>
                    <div className="container">
                      {roleName === "ATG Delegate" &&
                      atgPres === countryName ? (
                        <select
                          name="sendToCountry"
                          id="sendToCountry"
                          className={`input__one account__input account__dropDown`}
                          required
                          value={this.state.sendToCountry}
                          onChange={(val) => this.selectCountry(val)}
                        >
                          <option value="null" disabled>
                            Select a country
                          </option>
                          {countries.country_data
                            .filter((c) => c.country_name !== atgPres)
                            .sort(
                              (a, b) =>
                                b.country_name.toUpperCase() <
                                a.country_name.toUpperCase()
                            )
                            .map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {item.country_name}
                                </option>
                              );
                            })}
                        </select>
                      ) : (
                        <select
                          name="sendToCountry"
                          id="sendToCountry"
                          className={`input__one account__input account__dropDown`}
                          required
                          value={this.state.sendToCountry}
                          onChange={(val) => this.selectCountry(val)}
                        >
                          <option value="null" disabled>
                            Select a country
                          </option>
                          {countries.country_data
                            .filter((c) => c.id !== countryId)
                            .sort(
                              (a, b) =>
                                b.country_name.toUpperCase() <
                                a.country_name.toUpperCase()
                            )
                            .map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {item.country_name}
                                </option>
                              );
                            })}
                        </select>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-wrap flex-40-60">
                    <div className="container">
                      <p style={{ marginTop: 10 }}>Annual Commitment ($)</p>
                    </div>
                    <div className="container">
                      {roleName === "ATG Delegate" ? (
                        <NumberFormat
                          id="amount"
                          name="sendAmount"
                          displayType="input"
                          decimalScale="1"
                          className={`input__one account__input`}
                          value={this.state.inputValue}
                          thousandSeparator={true}
                          prefix={"$"}
                          required="required"
                          allowNegative={false}
                          allowLeadingZeros={false}
                          //   defaultValue={0}
                          onValueChange={(e) => this.onChange(e)}
                        />
                      ) : (
                        <div>
                          <NumberFormat
                            id="amount"
                            name="sendAmount"
                            displayType="input"
                            decimalScale="1"
                            className={`input__one account__input`}
                            value={this.state.inputValue}
                            thousandSeparator={true}
                            prefix={"$"}
                            required="required"
                            allowNegative={false}
                            allowLeadingZeros={false}
                            // defaultValue={0}
                            onValueChange={(e) => this.onChange(e)}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <br />
                  <button
                    type="submit"
                    className="policyBtn button"
                    disabled={
                      hasGameStarted
                        ? isTransferAllowed && gameHasAdvanced
                          ? transferRequestSent
                            ? "disabled"
                            : false
                          : "disabled"
                        : "disabled"
                    }
                  >
                    {isTransferAllowed
                      ? transferRequestSent
                        ? "Sending . . ."
                        : "Send Money"
                      : "Insufficient budget"}
                  </button>
                </form>
              ) : null}
              {Object.keys(transactions).length > 0 ? (
                <TransactionTable
                  transactions={transactions}
                  isMoneyTransaction={countryId > 0}
                  forATG={roleName === "ATG Delegate"}
                  roleName={roleName}
                  atgPres={atgPres}
                  countryName={countryName}
                  cancelMoney={this.cancelMoney}
                  cancelATGMoney={this.cancelATGMoney}
                  moneyAlert={this.props.moneyAlert}
                  cancelMoneyAlert={this.props.cancelMoneyAlert}
                  buttonAlert={this.props.buttonAlert}
                  atgMoneyAlert={this.props.atgMoneyAlert}
                  cancelAtgMoneyAlert={this.props.cancelAtgMoneyAlert}
                  atgButtonAlert={this.props.atgButtonAlert}
                  cancelTo={this.props.cancelTo}
                  atgCancelTo={this.props.atgCancelTo}
                />
              ) : (
                <div>
                  <br />
                  <h4>No transactions.</h4>
                </div>
              )}
            </div>
          </div>
        </div>
      </Provider>
    );
  }
}

MoneyTransfer.propTypes = {
  onSendMoney: PropTypes.func.isRequired,
  transferRequestSent: PropTypes.bool.isRequired,
  transactions: PropTypes.object.isRequired,
  countryId: PropTypes.number.isRequired,
  roleName: PropTypes.string.isRequired,
  countryName: PropTypes.string.isRequired,
  hasGameStarted: PropTypes.bool.isRequired,
  atgPres: PropTypes.string.isRequired,
};

export default inject("countries", "metrics")(MoneyTransfer);
